import { Table } from 'antd';
import classNames from 'classnames/bind';
import { lodashFilter } from 'components/hoc/index';
import React, { Fragment, PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Enums from 'utils/EnumsManager';
import { resetPreview } from 'views/ReportPreview/flow/actions';
import { insertGroupRows, produceRowData, appendTotalRow } from '../HOCs/index';
import styles from '../index.less';

const cx = classNames.bind(styles);

const { GROUPS, OTHERS, AGGREGATES } = Enums.DROPZONES;
const zones = [GROUPS, OTHERS, AGGREGATES];
const { SUMMARYKEY, GROUPROWKEY, TOTALROWKEY } = Enums.REPORTS.PREVIEW;

// TODO: Add propType

class SummaryPreviewTable extends PureComponent {
  componentWillUnmount() {
    this.props.resetPreview();
  }

  hiddenCellRenderer = colNumber => ({ props: { colSpan: colNumber } })

  summaryCellRenderer = (record, colId) => {
    const i18n = 'page.ReportPreview.summary';
    const getColData = record[SUMMARYKEY].data.find(data => data.id === colId);
    const children = (
      <div className={cx('summary')}>
        <Fragment key={colId}>
          {getColData.sum && (
            <FormattedMessage
              id={`${i18n}.sum`}
              values={{
                val: getColData.sum
              }}
              tagName="span"
            />
          )}
          {getColData.avg && (
            <FormattedMessage
              id={`${i18n}.avg`}
              values={{
                val: getColData.avg
              }}
              tagName="span"
            />
          )}
        </Fragment>
      </div>
    );
    return {
      children,
    };
  }

  groupByRender = (record, key) => {
    const { usedColumns } = this.props;
    const groupByInfo = usedColumns.find(col => col.name === key);
    const label = groupByInfo.label ? groupByInfo.label : '';
    return <p>{label}: {record[key]}</p>;
  }

  groupColumnRenderer = (text, record, keys) => {
    if (record[TOTALROWKEY]) {
      return {
        children: (
          <FormattedMessage id="page.ReportPreview.total" />
        ),
        props: null
      };
    }
    if (record[GROUPROWKEY]) {
      return {
        children: (
          <div className={classNames(cx('groupby-label'))}>
            {
              keys.map(key => (this.groupByRender(record, key)))
            }
            <FormattedMessage
              id="page.ReportPreview.summary.count"
              values={{
                val: record[SUMMARYKEY].count
              }}
              tagName="p"
            />
          </div>
        ),
        props: {
          rowSpan: record[SUMMARYKEY].count + 1,
          className: cx('bgWhite'),
        },
      };
    }
    return {
      children: null,
      props: {
        rowSpan: 0,
      }
    };
  }

  renderColumns = () => {
    const { usedColumns } = this.props;

    const groupColumns = usedColumns.filter(uCol => uCol.belongTo === GROUPS);
    const groupColumnsKeys = groupColumns.map(col => col.name);
    const groupColumnDefs = !_.isEmpty(groupColumns) ? [{
      title: 'Group by',
      render: (text, record) => this.groupColumnRenderer(text, record, groupColumnsKeys),
    }] : [];

    const restColumns = usedColumns.filter(uCol => uCol.belongTo !== GROUPS && !uCol.fieldRestricted && _.isEmpty(uCol.actions));
    const restColumnDefs = restColumns.map((rCol, i) => ({
      dataIndex: rCol.name,
      title: rCol.label,
      render: (text, record) => {
        if (record[GROUPROWKEY] || record[TOTALROWKEY]) {
          return i === 0 ? this.hiddenCellRenderer(restColumns.length) : this.hiddenCellRenderer(0);
        }
        return text;
      }
    }));

    const aggregatesColumns = usedColumns.filter(uCol => uCol.belongTo !== GROUPS && !uCol.fieldRestricted && !_.isEmpty(uCol.actions));
    const aggregatesColumnsDefs = aggregatesColumns.map((rCol, i) => ({
      dataIndex: rCol.name,
      title: rCol.label,
      render: (text, record) => {
        if (record[GROUPROWKEY] || record[TOTALROWKEY]) {
          return this.summaryCellRenderer(record, rCol.id);
        }
        return text;
      },
    }));

    return [
      ...groupColumnDefs,
      ...restColumnDefs,
      ...aggregatesColumnsDefs,
    ];
  }

  render() {
    return (
      <Table
        dataSource={this.props.data}
        columns={this.renderColumns()}
        className="fixedTable"
        rowKey={(record, i) => i}
        size="small"
        pagination={false}
        bordered
        rowClassName={record => (cx({
          bgGrey: record[GROUPROWKEY] || record[TOTALROWKEY],
          bgWhite: !(record[GROUPROWKEY] || record[TOTALROWKEY]),
          bold: record[TOTALROWKEY],
        }))}
      />
    );
  }
}

const mapStateToProps = ({ global, reportSetup }) => ({
  lang: global.language,
  columns: reportSetup.preview.columns,
});

const mapDispatchToProps = {
  resetPreview,
};

const enhancers = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lodashFilter('columns', 'usedColumns', record => zones.indexOf(record.belongTo) > -1),
  produceRowData('usedColumns', 'data'),
  insertGroupRows('data', 'data'),
  appendTotalRow('data', 'data'),
);

export default enhancers(SummaryPreviewTable);



// WEBPACK FOOTER //
// ./src/views/ReportPreview/components/SummaryPreviewTable.jsx